
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[ssgParams]/products/locals",
      function () {
        return require("private-next-pages/[ssgParams]/products/locals.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[ssgParams]/products/locals"])
      });
    }
  